import { Flex, Image, Text } from '@chakra-ui/core'
import * as React from 'react'
import { images } from '../../theme'
import { H2 } from '../../typography'
import RevealFlex from '../RevealFlex/index'

type EmptyListHandlerProps = {
  title?: string
  subTitle?: string
}

const EmptyListHandler: React.FC<EmptyListHandlerProps> = ({ title, subTitle }) => {
  return (
    <RevealFlex>
      <Image src={images.noData} width="300px" maxWidth="100%" />
      <Flex
        flexDirection="column"
        textAlign="center"
        w="100%"
        justify="center"
        align="center"
        px={6}
      >
        <H2 fontWeight="400">{title}</H2>
        <Text fontWeight="light">{subTitle}</Text>
      </Flex>
    </RevealFlex>
  )
}

export default EmptyListHandler

EmptyListHandler.defaultProps = {
  title: 'Nothing to see here, yet.',
  subTitle: 'Go ahead and create your first record to get started.'
}
